import React, {
  ReactNode,
  createContext,
  useContext,
  useMemo,
  useState,
} from 'react'

type ISelectedSocietyContext = {
  selectedSocietyId: string | undefined
  setCurrentSocietyId: (societyId?: string) => void
}

const SelectedSocietyContext = createContext<null | ISelectedSocietyContext>(
  null
)

export const SelectedSocietyContextProvider = ({
  children,
}: {
  children?: ReactNode
}): ReactNode => {
  const [selectedSocietyId, setSelectedSocietyId] = useState<string>()

  const values = useMemo(() => {
    const setCurrentSocietyId = (societyId?: string): void => {
      setSelectedSocietyId(societyId)
    }
    return {
      selectedSocietyId,
      setCurrentSocietyId,
    }
  }, [selectedSocietyId, setSelectedSocietyId])
  return (
    <SelectedSocietyContext.Provider value={values}>
      {children}
    </SelectedSocietyContext.Provider>
  )
}

export const useSelectedSocietyId = (): ISelectedSocietyContext => {
  const context = useContext(SelectedSocietyContext)
  if (!context) {
    throw new Error(
      'useSelectedSociety, must be used inside SelectedSocietyContextProvider'
    )
  }
  return context
}
